export const ScrollHelper = {
    /*Finds the first ancestor of the element that is vertically scrollable.
     * Walks up the element tree (using parentElement) and checks if the ancestor has
     * overflow set to scroll or auto, and if there's enough content to allow scrolling. */
    findScrollContainer(el) {
        let current = el?.parentElement;
        while (current) {
            const tag = current.tagName.toLowerCase();
            if (tag === 'body' || tag === 'html')
                break;
            const style = getComputedStyle(current);
            const isScrollable = style.overflowY === 'auto' ||
                style.overflowY === 'scroll' ||
                style.overflow === 'auto' ||
                style.overflow === 'scroll';
            if (isScrollable && current.scrollHeight > current.clientHeight) {
                return current;
            }
            current = current.parentElement;
        }
        return null;
    },
    /* Calculates the vertical offset (offsetTop) of the element relative to a container.
     * Adds up the offsetTops while walking up the DOM tree until reaching the given container.
     * Useful to determine the exact scroll position of an element inside a scrollable container. */
    getOffsetTopRelativeToContainer(el, container) {
        let offset = 0;
        let current = el;
        while (current && current !== container) {
            offset += current.offsetTop;
            current = current.offsetParent;
        }
        return offset;
    },
    /* Scrolls the element into view, aligning it below a fixed offset (e.g., header), without exceeding the page height.
     * In microfrontend contexts, it scrolls a scrollable ancestor if available (e.g., overflow: auto/scroll),
     * falling back to window.scrollTo when no such container is found. */
    scrollTo(ref, offset = 0) {
        if (!ref?.current)
            return;
        const scrollContainer = ScrollHelper.findScrollContainer(ref.current);
        if (scrollContainer) {
            const topOffset = ScrollHelper.getOffsetTopRelativeToContainer(ref.current, scrollContainer);
            const maxScroll = scrollContainer.scrollHeight - scrollContainer.clientHeight;
            scrollContainer.scrollTo({
                top: Math.min(topOffset - offset, maxScroll),
                behavior: 'smooth'
            });
            return;
        }
        const topOffset = ref.current.getBoundingClientRect().top + window.scrollY - offset;
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        window.scrollTo({
            top: Math.min(topOffset, maxScroll),
            behavior: 'smooth'
        });
    }
};
